import React, { useState } from 'react';
import Squad from '~/pages/Match/subpages/Previous/components/Squad';
import Stats from '~/pages/Match/subpages/Previous/components/Stats';
import EmptyPage from '~/pages/EmptyPage';
import { theme } from '~/styles/theme';
import { useSelector } from 'react-redux';
import { propTypes, defaultProps } from './propsValidation';
import * as S from '../styles';

export default function Previous({
  selectedMatch,
  lineup,
  statsData,
  isFetching,
  lineupFetchFailed,
  teamStatsFailed,
}) {
  const [tab, setTab] = useState('local');
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const styleTab = {
    secondaryColor: match?.competitionId === 1 ? theme.coral : theme.turquoise,
  };
  if (lineupFetchFailed && teamStatsFailed) return <EmptyPage />;
  return (
    <S.ContainerSm>
      <S.TabsSections
        onChange={({ value }) => setTab(value)}
        value={tab}
        localTeam={selectedMatch ? selectedMatch.homeTeam.nickname : null}
        awayTeam={selectedMatch ? selectedMatch.awayTeam.nickname : null}
        styleTab={styleTab}
      />
      {tab === 'local' && (
        <Squad
          team={selectedMatch ? selectedMatch.homeTeam : null}
          squad={
            lineup.homeTeamLineUp ? lineup.homeTeamLineUp.startPlayers : []
          }
          substitutes={
            lineup.homeTeamLineUp
              ? lineup.homeTeamLineUp.substitutesPlayers
              : []
          }
          trainer={lineup.homeTeamLineUp ? lineup.homeTeamLineUp.trainer : {}}
          formation={
            lineup.homeTeamLineUp ? lineup.homeTeamLineUp.playersFormation : []
          }
          isLocal
          isFetching={isFetching}
          lineupFetchFailed={lineupFetchFailed}
        />
      )}
      {tab === 'stats' && (
        <Stats statsData={statsData} teamStatsFailed={teamStatsFailed} />
      )}
      {tab === 'away' && (
        <Squad
          team={selectedMatch ? selectedMatch.awayTeam : null}
          squad={
            lineup.awayTeamLineUp ? lineup.awayTeamLineUp.startPlayers : []
          }
          substitutes={
            lineup.awayTeamLineUp
              ? lineup.awayTeamLineUp.substitutesPlayers
              : []
          }
          trainer={lineup.awayTeamLineUp ? lineup.awayTeamLineUp.trainer : {}}
          formation={
            lineup.awayTeamLineUp ? lineup.awayTeamLineUp.playersFormation : []
          }
          isFetching={isFetching}
          lineupFetchFailed={lineupFetchFailed}
        />
      )}
    </S.ContainerSm>
  );
}

Previous.propTypes = propTypes;

Previous.defaultProps = defaultProps;
